import React, { useEffect, useState, useRef } from "react";
import Button from "react-bootstrap/Button";
import { useSelector } from "react-redux";

const OrderAlert = () => {
  const [isShowAlert, setIsShowAlert] = useState(false);
  const { cartList } = useSelector((state) => state.cart);
  const intervalRef = useRef(null);

  const startChecking = (delay = 4000) => {
    if (intervalRef.current) clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      const now = new Date();
      const currentHour = now.getUTCHours();
      const currentMinute = now.getUTCMinutes();

      console.log('UTC Time:', currentHour,currentMinute)

      const isWithinTimeRange =
        (currentHour === 9 && currentMinute === 30) ||
        (currentHour === 15 && currentMinute === 0);

      if (isWithinTimeRange && cartList?.length > 0) {
        setIsShowAlert(true);
      }
    }, delay);
  };

  useEffect(() => {
    startChecking();

    return () => clearInterval(intervalRef.current); // cleanup on unmount
  }, [cartList]);

  const handleClose = () => {
    setIsShowAlert(false);
    // Restart checking after 15 seconds
    startChecking(15000);
  };

  if (!isShowAlert) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-full z-30 bg-black/50 flex items-center justify-center">
      <div className="p-5 rounded-lg text-center bg-white shadow-lg">
        <p className="text-2xl font-bold">Alert</p>
        <p className="text-lg my-3">
          Έχετε προϊόντα στο καλάθι σας που δεν έχουν αποσταλεί.
        </p>
        <Button onClick={handleClose}>Close</Button>
      </div>
    </div>
  );
};

export default OrderAlert;
